<template>
  <CCard>
    <CCardHeader style="display: inline-flex">
      <slot name="header">
        <CIcon name="cil-grid" />Generate Revenue Report
      </slot>
      <VueCtkDateTimePicker
          :overlay=true
          :range=true
          :no-label=true
          label="Select Date Range"
          id="RangeDatePicker"
          format="YYYY-MM-DD"
          formatted="ll"
          color="#FF2E75"
          v-model="date_range"
          :max-date = current_date
      >
      </VueCtkDateTimePicker>
    </CCardHeader>
    <CCardHeader>
      <CButton class="center-div btn-block w-50 h-50" color="primary" @click="generateReport" v-if="loading===false">Generate Report</CButton>
    </CCardHeader>
    <div class="w-100 mb-2 mt-4 mr-3 d-flex justify-content-end">
      <div class="input-group w-25 mr-3">
        <input type="text" class="form-control" v-model="search" placeholder="Search on start date" aria-label="Search on start date" aria-describedby="basic-addon2">
        <div class="input-group-append">
          <span class="input-group-text" id="basic-addon2">Search</span>
        </div>
      </div>
    </div>
    <CCardBody v-if="show">
      <table class="table">
        <thead>
        <tr>
          <th scope="col">Date Range</th>
          <th scope="col">Start Date</th>
          <th scope="col">End Date</th>
          <th scope="col">Action</th>
        </tr>
        </thead>
        <tbody>
          <tr v-for="report in filterRevenue" :key="report.id">
            <td>{{ report.report_name }}</td>
            <td>{{ report.start_date }}</td>
            <td>{{ report.end_date}}</td>
            <td>
              <div class="d-flex justify-content-start">
                <export-excel
                    :data   = "report.report_data"
                    :fields = "columns"
                    worksheet = "My Worksheet"
                    :name    = "report.report_name + '.xls'">
                  <span class="mr-2"><i class="fa fa-download" aria-hidden="true"></i></span>
                </export-excel>

                <span @click="deleteReport(report.id)"><i class="fa fa-trash" aria-hidden="true"></i></span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </CCardBody>
  </CCard>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import axios from "axios";
import excel from 'vue-excel-export';
import _ from 'lodash';
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
Vue.use(excel)

export default {
  name: "GenerateRevenueReport",
  data() {
    return {
      current_date: moment().subtract(1, 'days').clone().format('YYYY-MM-DD hh:mm').toString(),
      date_range:  {
        'start' : null,
        'end' : null
      },
      show: false,
      loading: false,
      selected_report: 'Revenue Report',
      revenues: [],
      columns: {
        'Time': 'Time',
        'Service name': 'Service name',
        'Total Revenue': 'Total Revenue',
        'Total Subscription Revenue': 'Total Subscription Revenue',
        'Total Active Subscriber': 'Total Active Subscriber',
        'Cancelled Subscription' : 'Cancelled Subscription',
        'New Subscription Attempt': 'New Subscription Attempt',
        'New Subscription Revenue': 'New Subscription Revenue',
        'New Subscription count': 'New Subscription count',
        'Re-order Attempt': 'Re-order Attempt',
        'Re-order Revenue': 'Re-order Revenue',
        'Re-order count': 'Re-order count',
        'On-Demanded Count': 'On-Demanded Count',
        'On-Demanded Revenue': 'On-Demanded Revenue'
      },
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],
      search: '',
    }
  },
  created() {
    this.getRevenueReport();
  },
  methods: {
    showReport(){
      this.show=false;
      this.revenues = [];
      this.loadingData();
    },
    getRevenueReport(){
      axios({
        method: 'get',
        url: `${ADMIN_URL}/revenue-report-list`,
      })
          .then(response => {
            this.show = true;
            this.revenues = response.data.data;
          })
          .catch(() => {
            this.$swal('Error', 'Something Went Wrong', 'error');
          });
    },
    generateReport() {
      let exist_revenue_data = this.revenues.filter(revenue => {
        return revenue.start_date === this.date_range.start && revenue.end_date === this.date_range.end;
      })
      if (_.isEmpty(exist_revenue_data)) {
        axios({
          method: 'post',
          url: `${ADMIN_URL}/generate-report`,
          data: {
            date_range: this.date_range,
          }
        })
            .then(response => {
              if (response.data.success) {
                this.$swal('Success', 'Please refresh page after few minute later', 'success');
              } else {
                this.$swal('Success', response.data.message, 'success');
              }

            })
            .catch(e => {
              console.log(e.data)
              this.$swal('Error', 'Something Went Wrong', 'error');
            });
        return;
      }
      this.$swal('Success', 'Report Already exists.', 'success');
      this.search = this.date_range.start;
    },
    deleteReport(id) {
      this.$swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.value) {

          axios({
            method: 'post',
            url: `${ADMIN_URL}/revenue-report-delete`,
            data: {
              report_id: id
            }
          })
              .then(() => {
                this.getRevenueReport();
              })
              .catch(() => {
                this.$swal('Error', 'Something Went Wrong', 'error');
              });
        }
      });
    },

  },
  computed: {
    filterRevenue() {
      if (this.search.length === 0) {
        return this.revenues;
      }

      return this.revenues.filter(revenue => {
        return revenue.start_date === this.search;
      })

    }
  }
}
</script>

<style scoped>

</style>
